import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import {Button} from "reactstrap";
import UserRoles from "../../../../../constants/UserRoles";
import Types from "../../../../../constants/Types";
import moment from "moment-timezone";
import API from "@beardeddevops/react.api";

const breadcrumbsStatic = [{
	name: 'Sales',
	url: '/stripe',
	icon: 'card',
}];

class Stripe_Charges extends Framework.Components.View {
	handleToggleModal = async (modal) => {
		this.setState({[modal]: !this.state[modal]})
	}

	render() {
		const {history} = this.props;
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={history}>
					<Button data-id="add-phoneLog" onClick={async () => {await this.handleToggleModal('modalStripeAdd')}} size="sm" color="primary">
						<i className="fa fa-phone"/>&nbsp;&nbsp;Make a Sale
					</Button>
				</Framework.Components.PageBar>

				<Collections.StripeCharges
					key={this.state.key}
					history={this.props.history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					regions={this.props.regions}
					showCSV={this.props.roles.includes(UserRoles.Admin)}
					isFE={this.props.roles.includes(UserRoles.FieldEngineer) && this.props.roles.length === 1}
					showMergeButton={this.props.roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Executive].includes(role))}

				/>
				<Framework.Elements.UniversalModal
					hasSubmit={false}
					locations={this.props.regions}
					title={"Make a Sale"}
					name={"Make a Sale"}
					object={Objects.StripeCharge}
					history={history}
					toggle={this.state.modalStripeAdd}
					showModal={this.state.modalStripeAdd}
					reportClose={this.reportClose('modalStripeAdd')}
					size={"xl"}
					objectProps={{isNew: true, afterSave: async () => {
						this.setState({key: Math.random()})
						this.setState({modalStripeAdd: false})
					}}}
				/>


			</div>
		);
	}
}

export default Framework.Components.withRootState(Stripe_Charges);
